import { ref as i, onActivated as r } from "vue";
const e = [];
for (let n = 0; n < 256; ++n)
  e.push((n + 256).toString(16).slice(1));
function m(n, t = 0) {
  return (e[n[t + 0]] + e[n[t + 1]] + e[n[t + 2]] + e[n[t + 3]] + "-" + e[n[t + 4]] + e[n[t + 5]] + "-" + e[n[t + 6]] + e[n[t + 7]] + "-" + e[n[t + 8]] + e[n[t + 9]] + "-" + e[n[t + 10]] + e[n[t + 11]] + e[n[t + 12]] + e[n[t + 13]] + e[n[t + 14]] + e[n[t + 15]]).toLowerCase();
}
let o;
const p = new Uint8Array(16);
function y() {
  if (!o) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    o = crypto.getRandomValues.bind(crypto);
  }
  return o(p);
}
const g = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), d = { randomUUID: g };
function c(n, t, l) {
  if (d.randomUUID && !n)
    return d.randomUUID();
  n = n || {};
  const u = n.random ?? n.rng?.() ?? y();
  if (u.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return u[6] = u[6] & 15 | 64, u[8] = u[8] & 63 | 128, m(u);
}
const a = () => {
  const n = i(c());
  return r(() => {
    n.value = c();
  }), { uuidValue: n };
};
export {
  a as u
};
//# sourceMappingURL=useUuid-BGpRkYny.js.map
